import { Map } from 'immutable'
import React, { useEffect } from 'react'
import { RenderFormControl } from '../../FormControls/RenderFormControl'

export function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter, id, filterPlaceholder, captions },
  keepFilterCols,
  setFilterCols,
  elementClasses,
  component,
  setPage,
  uid,
}) {
  const count = preFilteredRows.length

  useEffect(() => {
    if (keepFilterCols[id] && !filterValue) {
      setFilter(keepFilterCols[id])
    }
  }, [])

  const onHandleClick = (evt) => {
    evt.stopPropagation()
  }

  const onHandleChange = (evt) => {
    // keepFilterCols[id] = evt.target.value || undefined;
    // setFilterCols(keepFilterCols)
    setFilter(evt.target.value || undefined)
    if (evt.target.value) {
      setPage(0)
    }
  }

  let placeholder = component.getIn(['props', 'captions', 'Column Text Filter'])
  if (!placeholder) {
    placeholder = filterPlaceholder ? filterPlaceholder : `Search ${count} records...`
  }

  if (placeholder && filterPlaceholder) {
    placeholder = filterPlaceholder
  }

  return (
    <RenderFormControl
      label={''}
      value={filterValue || ''}
      onChange={onHandleChange}
      onClick={onHandleClick}
      themeKey="PrjPowerTableFilterField"
      placeholder={placeholder}
      // type={column.fieldType}
      // field={id}
      styleKey={`ft--${uid}`}
      fullWidth
    />
  )
}
